<div
  class="content layout padding-top"
  fxLayout.gt-md="row"
  fxLayoutAlign.gt-md="center start"
  fxLayoutGap.gt-md="48px"
  fxLayout="column"
  fxLayoutAlign="start center"
  fxFlexFill.lt-lg
  ngClass.lt-lg="fit-content"
>
  <form [formGroup]="form">
    <div
      fxLayout.gt-md="row"
      fxLayoutAlign.gt-md="start start"
      fxLayoutGap.gt-md="48px"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <div>
        <div
          fxLayout="column"
          fxLayoutAlign="start start"
          [ngClass.xl]="'form-field-lg'"
          [ngClass.lg]="'form-field-md'"
          [ngClass.lt-lg]="'form-field-lg'"
          [ngClass.xs]="'form-field-xs'"
        >
          <mat-form-field appearance="outline">
            <mat-label>Legal entity name</mat-label>
            <input
              matInput
              type="text"
              name="businessName"
              formControlName="businessName"
              placeholder="Legal entity name"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Bank name</mat-label>
            <input matInput type="text" name="bankName" formControlName="bankName" placeholder="Bank name" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Bank account type</mat-label>
            <mat-select
              matInput
              name="bankAccountType"
              formControlName="bankAccountType"
              placeholder="Bank account type"
            >
              <mat-option *ngFor="let option of bankAccountTypeOptions" [value]="option.value">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Account number</mat-label>
            <input
              matInput
              type="text"
              name="accountNumber"
              formControlName="accountNumber"
              placeholder="Account number"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Routing number</mat-label>
            <input
              matInput
              type="text"
              name="routingNumber"
              formControlName="routingNumber"
              placeholder="Routing number"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Bank designation (global)</mat-label>
            <mat-select
              matInput
              name="bankAccountDesignationEntity"
              formControlName="bankAccountDesignationEntity"
              placeholder="Bank designation (global)"
            >
              <mat-option *ngFor="let option of globalDesignationOptions" [value]="option.value">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Verification status</mat-label>
            <mat-select
              matInput
              name="verificationStatus"
              formControlName="verificationStatus"
              placeholder="Verification status"
            >
              <mat-option [value]="true">Verified</mat-option>
              <mat-option [value]="false">Unverified</mat-option>
            </mat-select>
          </mat-form-field>

          <ifc-datepicker
            [fc]="form.get('lastCheckDate')"
            [label]="'Verification date'"
            [disabled]="!canEditVerificationDate"
            (clearInput)="clearDate('lastCheckDate')"
          ></ifc-datepicker>

          <button mat-button *ngIf="canPullExtraInfo" (click)="syncExtraInfo()" [disabled]="data.viewMode">
            <mat-icon class="layout margin-right-sm">sync</mat-icon>
            Sync account
          </button>
        </div>
      </div>
    </div>
  </form>

  <div>
    <ifb-card>
      <mat-card appearance="raised" class="card">
        <mat-card-header>
          <mat-card-title>Bank account details</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mat-card-content-lg no-bottom-padding">
          <ifc-horizontal-list [items]="bankAccountListItems">
            <ng-template horizontalListCustomTemplate="linkStatusValue">
              <ifb-bank-account-link-status-icon-chip
                class="status-icon"
                [status]="linkStatus"
              ></ifb-bank-account-link-status-icon-chip>
            </ng-template>
            <ng-template horizontalListCustomTemplate="missingInfo">
              <div class="missing-info">
                <div class="missing-info__header">Missing information</div>
                <ul>
                  <li class="secondary-text" *ngFor="let info of data.bankAccount?.missingInformation">
                    {{ info }}
                  </li>
                </ul>
              </div>
            </ng-template>
          </ifc-horizontal-list>
        </mat-card-content>
      </mat-card>
    </ifb-card>

    <form [formGroup]="form" class="layout padding-top scroll-margin-bottom">
      <mat-checkbox color="primary" formControlName="screenShareRequired">Screen share required</mat-checkbox>
    </form>
  </div>

  <mat-card
    *ngIf="data?.bankAccount?.syncedBankAccount"
    appearance="raised"
    [ngClass.xl]="'card lg'"
    [ngClass.lg]="'card md'"
    [ngClass.lt-lg]="'card lg'"
    [ngClass.xs]="'card xs'"
    class="card"
  >
    <mat-card-header>
      <mat-card-title>Bank integration details</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-card-content-lg no-bottom-padding">
      <ifc-horizontal-list [items]="bankIntegrationListItems"></ifc-horizontal-list>
    </mat-card-content>
  </mat-card>
</div>
